// extracted by mini-css-extract-plugin
export default {"product__slider":"ProductSlider_product__slider__V-B2N"};